// Field kinds the wizard knows how to render. Adding a kind = extend the wizard
// FieldRenderer switch. Event types reference these by string.
export const FIELD = {
  TEXT: "text",
  TEXTAREA: "textarea",
  DATE: "date",
  TOGGLE: "toggle",
  CHIPS: "chips", // array of short strings (topics)
  SPEAKERS: "speakers", // array of { name, title, org }
  CONTACTS: "contacts", // array of { name, designation, mobile, email }
  CUSTOM_SLIDES: "customSlides", // array of { title, body, image }
  HERO_IMAGE: "heroImage", // single uploaded image path
  SCHEDULE: "schedule", // array of day/grouped agenda-style rows
  EMAIL: "email",
  URL: "url",
  REGISTRATION_FIELDS: "registrationFields",
};
